import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const totalUsersAction = createAsyncThunk(
    'total-users',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/total-users`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const totalUsersSlice = createSlice({
    name: 'total-users',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(totalUsersAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(totalUsersAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(totalUsersAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const totalUsersReducer = totalUsersSlice.reducer
